// Central SEO configuration — single source of truth for per-route metadata.
export const SITE_URL = "https://workpay-app.com";
export const OG_IMAGE = `${SITE_URL}/og-image.png`;
export const BRAND = "WorkPay";

export const abs = (path) => {
  if (!path || path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

// Indexable public pages
export const SEO = {
  "/": {
    title: "WorkPay UAE — Project & Milestone Payments, Dubai",
    description:
      "WorkPay helps UAE and Dubai service vendors collect project payments, track milestones and reduce payment delays, while customers stay protected — powered by Stripe.",
  },
  "/pricing": {
    title: "WorkPay Pricing — Simple Links & Milestone Payments",
    description:
      "WorkPay pricing for service vendors: Simple Payment Links at 2.9% + AED 1 and Milestone Payments at 3.95% + AED 1 on UAE domestic cards. Payments processed through Stripe.",
  },
  "/contact": {
    title: "Contact WorkPay | Talk to Our Team",
    description:
      "Get in touch with the WorkPay team about project payments, milestones, payouts or early access. We usually reply within 1–2 business days.",
  },
  "/about": {
    title: "About WorkPay — Built for UAE Project Businesses",
    description:
      "Meet WorkPay founder Roshan Hegde and learn how real payment and milestone challenges at a UAE project business led to a clearer workflow for vendors and customers.",
  },
  "/refund-and-dispute-policy": {
    title: "Refund & Dispute Policy — WorkPay",
    description:
      "How refunds and disputes are handled for payments made through WorkPay. Payments are processed through Stripe; WorkPay provides workflow and documentation, not legal escrow.",
  },
  "/how-payments-work": {
    title: "How Payments Work — WorkPay",
    description:
      "A plain-language explanation of how money moves with WorkPay: Stripe processes payments, WorkPay manages the project and milestone workflow, and approved milestones become eligible for Stripe payouts.",
  },
  "/terms-and-conditions": {
    title: "Terms & Conditions — WorkPay",
    description:
      "Read the WorkPay Terms & Conditions covering accounts, vendor and customer responsibilities, payments, payouts, disputes and account deletion.",
  },
  "/privacy-policy": {
    title: "Privacy Policy — WorkPay",
    description:
      "Learn how WorkPay collects, uses, stores and protects your personal information across the website, app and Stripe-powered payment workflow.",
  },
  "/delete-account-data": {
    title: "Delete Account & Data — WorkPay",
    description:
      "Request deletion of your WorkPay account and associated personal data. Learn how to request deletion and what happens after your request is received.",
  },
  "/why-workpay/customer-protection": {
    title: "Customer Protection — WorkPay",
    description:
      "See how WorkPay protects customers with milestone approvals, protected project payments and structured dispute documentation before money is released.",
  },
  "/why-workpay/why-vendors-choose-workpay": {
    title: "Why Vendors Choose WorkPay",
    description:
      "Why service vendors choose WorkPay: protected project payments, milestone tracking, customer approvals and daily payouts — instead of chasing invoices.",
  },
  "/why-workpay/workpay-vs-bank-transfers": {
    title: "WorkPay vs Bank Transfers",
    description:
      "Compare WorkPay with plain bank transfers: milestone tracking, customer approvals, protected payouts and dispute documentation built for service projects.",
  },
  "/why-workpay/workpay-vs-payment-links": {
    title: "WorkPay vs Payment Links",
    description:
      "Payment links only collect money. WorkPay adds milestones, customer approvals, protected payouts and dispute documentation for service businesses.",
  },
};

// Routes that must be excluded from indexing (noindex, nofollow).
export const NOINDEX_ROUTES = ["/investor", "/pitch", "/pitch/print"];

// Public routes included in sitemap.xml with genuine last-modified dates.
export const SITEMAP = Object.keys(SEO).map((path) => ({
  loc: abs(path),
  lastmod: "2026-05-31",
  priority: path === "/" ? "1.0" : "0.8",
}));
